import { getSceneDetailA, getHistorySceneDetailA, editSceneA, addSceneIntentA, deleteSceneIntentA } from '@/server/api'
import cloneDeep from 'lodash/cloneDeep'
import { Message, Modal } from 'view-design'
import { upgradeScene } from '@/utils/upgrade'
import { resetAllId } from '../utils/nodeIdPool';

const latestVer = '2.2';

const store = {
  namespaced: true,
  state: {
    isHistory: false, // 是否是历史版本
    sceneId: 0,
    sceneName: '',
    state: 0,
    createAt: 0,
    /** 话术更新时间（秒），接口未返回时为 0 */
    updateAt: 0,
    isRelease: -1, // 0: 未发布, 1: 已发布
    scene: {},
    industry: {
      industry: '',
      scene: '',
    }
  },
  mutations: {
    SET_SCENE_ID(state, { sceneId, isHistory = false }) {
      state.sceneId = ~~sceneId;
      state.isHistory = isHistory;
    },
    SET_SCENE(state, scene) {
      state.scene = scene;
    },
    SET_SCENE_NAME(state, name) {
      state.sceneName = name;
    },
    SET_SCENE_STATE(state, sceneState) {
      state.state = sceneState;
    },
    SET_SCENE_CREATE_AT(state, ts) {
      state.createAt = ts || 0;
    },
    SET_SCENE_UPDATE_AT(state, ts) {
      state.updateAt = ts || 0;
    },
    SET_SCENE_IS_RELEASE(state, isRelease) {
      state.isRelease = ~~isRelease;
    },
    UPDATE_SCENE_TEXT(state, text) {
      let obj = state.scene.scenes[text.id].nodes[text.iid].voices[text.vid];
      obj.text = text.originalText;
      obj.voice = "";
    },
    UPDATE_KNOWLEDGE_TEXT(state, text) {
      let obj = state.scene.knowledge[text.id].responses[text.iid];
      obj.text = text.originalText;
      obj.voice = "";
    },
    SET_INDUSTRY(state, industry) {
      state.industry = { ...industry };
    }
  },
  actions: {
    setScene({ dispatch, commit }, { sceneId, isHistory = false, force = false }) {
      commit('SET_SCENE_ID', { sceneId, isHistory });
      return dispatch('getSceneDetail').then((scene) => {
        dispatch('allotScene', { sceneData: scene, force });
        commit('SET_SCENE', scene);
        dispatch('flow/fetchHitStats', {}, { root: true });
        dispatch('knowledge/fetchHitStats', {}, { root: true });
      })
    },
    // 获取话术
    getSceneDetail({ dispatch, state, commit }) {
      if (state.isHistory) {
        getHistorySceneDetailA({
          id: state.sceneId,
        }).then((res) => {
          console.log('res :>> ', res);
        })
      }
      return getSceneDetailA({
        sceneId: state.sceneId,
      }).then((res) => {
        if (res.code !== 200) return Promise.reject();
        commit('SET_SCENE_NAME', res.data?.sceneName);
        commit('SET_SCENE_STATE', res.data?.state);
        commit('SET_SCENE_CREATE_AT', res.data?.createAt);
        commit('SET_SCENE_UPDATE_AT', res.data?.updateAt);
        commit('SET_SCENE_IS_RELEASE', res.data?.isRelease);
        commit('SET_INDUSTRY', { industry: res.data?.industry, scene: res.data?.scene });

        const sceneJsonStr = res.data?.sceneJson || '{}'
        let scene;
        try {
          scene = JSON.parse(sceneJsonStr);
        } catch (error) {
          Message.error('话术解析失败，请重试')
          return Promise.reject(error)
        }
        dispatch('upgradeScene', scene);
        return scene;
      })
    },
    // 保存话术
    saveScene({ dispatch, state, commit }, newScene) {
      return editSceneA({
        ver: 2,
        sceneId: state.sceneId,
        sceneJson: JSON.stringify(newScene)
      }).then((res) => {
        if (res.code !== 200) return Promise.reject();
        dispatch('allotScene', newScene);
        commit('SET_SCENE', newScene);
        return res.data
      })
    },

    // 保存部分修改
    savePortionScene({ dispatch, state }, { key, data }) {
      return dispatch('getSceneDetail').then((scene) => {
        const newScene = {
          ...scene,
          id: state.sceneId,
          version: '2.2',
          name: state.sceneName,
          [key]: data,
        }
        // 其它 Tab 局部保存时保留 scene 根上的 llmsettings，避免被接口旧数据冲掉
        if (
          key !== 'llmsettings' &&
          state.scene &&
          state.scene.llmsettings != null &&
          typeof state.scene.llmsettings === 'object'
        ) {
          newScene.llmsettings = state.scene.llmsettings
        }
        dispatch('saveSceneRelation', { oldScene: scene, newScene })
        return dispatch('saveScene', newScene)
      })
    },

    // 升级
    upgradeScene({ dispatch }, scene) {
      // 判断是否为旧版本
      if (Number(scene.version) >= Number(latestVer)) return;
      try {
        upgradeScene(scene).then(newScene => {
          return dispatch('saveScene', newScene)
        })
      } catch (error) {
        Message.error('升级失败，请联系运营人员')
      }
    },
    // 批量修改
    upgradeTexts({ commit, state, dispatch }, {textS, textK}) {
      for (let i = 0; i < textS.length; i++) {
        const text = textS[i];
        commit('UPDATE_SCENE_TEXT', text);
      }
      for (let i = 0; i < textK.length; i++) {
        const text = textK[i];
        commit('UPDATE_KNOWLEDGE_TEXT', text);
      }

      return editSceneA({
        ver: 2,
        sceneId: state.sceneId,
        sceneJson: JSON.stringify(state.scene)
      }).then((res) => {
        if (res.code !== 200) return Promise.reject();
        return res.data
      })

    },
    // 把话术分配到不同的仓库
    allotScene({ dispatch }, payload = {}) {
      const hasOptions = payload && Object.prototype.hasOwnProperty.call(payload, 'sceneData')
      const scene = hasOptions ? payload.sceneData : payload
      const force = hasOptions && payload.force === true
      const cloneScene = cloneDeep(scene);
      // 处理id，如果有错误的id 会返回 -1
      if (resetAllId(cloneScene) === -1) {
        // 这时cloneScene数据已经改变，需要保存
        dispatch('saveScene', cloneScene)
      }
      dispatch('flow/setFlows', {
        flows: cloneScene.scenes?.filter(item => !!item) || [],
        force,
      }, { root: true })
      dispatch('intents/setIntents', cloneScene.intents?.filter(item => !!item) || [], { root: true })
      dispatch('knowledge/setKnowledgeList', cloneScene.knowledge?.filter(item => !!item) || [], { root: true })
      dispatch('setting/setSettings', cloneScene.settings || {}, { root: true })
      dispatch('rules/setRules', cloneScene.rules?.filter(item => !!item) || [], { root: true })
      dispatch('eventRules/setEventRules', cloneScene.event_rules?.filter(item => !!item) || [], { root: true })
    },
    // 保存意图词库和话术的关联关系
    saveSceneRelation({ dispatch, state }, { oldScene, newScene }) {
      // 获取话术中所有的意图词库id
      const getKeywordIds = (scene) => {
        const ids = new Set();
        if (scene.intents) {
          scene.intents.forEach(intent => {
            if (intent.ref_id && typeof intent.ref_id === 'string') {
              ids.add(intent.ref_id)
            }
          })
        }
        if (scene.knowledge) {
          scene.knowledge.forEach(knowledge => {
            if (knowledge.ref_id && typeof knowledge.ref_id === 'string') {
              ids.add(knowledge.ref_id)
            }
          })
        }
        return Array.from(ids)
      }

      const oldRefIds = getKeywordIds(oldScene)
      const newRefIds = getKeywordIds(newScene)

      // 找出新增的意图词库id
      const addRefIds = newRefIds.filter(id => !oldRefIds.includes(id))
      // 找出删除的意图词库id
      const delRefIds = oldRefIds.filter(id => !newRefIds.includes(id))

      // 新增意图词库
      if (addRefIds.length) {
        for (let i = 0; i < addRefIds.length; i++) {
          addSceneIntentA({
            scene_id: state.sceneId,
            intent_id: addRefIds[i],
            scene_name: oldScene.name,
          })
        }
      }
      // 删除意图词库
      if (delRefIds.length) {
        for (let i = 0; i < delRefIds.length; i++) {
          deleteSceneIntentA({
            scene_id: state.sceneId,
            intent_id: delRefIds[i],
          })
        }
      }
    }
  },
}
export default store
